import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const StickyHeader = () => {
  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* BASIC STICKY HEADERS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Sticky Headers</h2>
        <div className="grid grid-cols-1 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Simple Sticky Header</label>
            <div className="relative h-40 overflow-y-auto bg-slate-950 rounded border border-slate-600">
              <div className="sticky top-0 bg-slate-800 border-b border-slate-600 px-3 py-2 font-medium text-slate-300 z-10">
                Header Title
              </div>
              <div className="p-3 space-y-2 text-sm text-slate-400">
                {[1,2,3,4,5].map(i => <p key={i}>Content line {i}</p>)}
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="sticky top-0 bg-slate-800 px-3 py-2 z-10">
  Header Title
</div>
<div className="p-3">Content</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Sticky with Shadow</label>
            <div className="relative h-40 overflow-y-auto bg-slate-950 rounded border border-slate-600">
              <div className="sticky top-0 bg-slate-800 shadow-lg px-3 py-2 font-medium text-slate-300 z-10 border-b border-slate-600">
                 Dashboard
              </div>
              <div className="p-3 space-y-2 text-sm text-slate-400">
                {[1,2,3,4,5].map(i => <p key={i}>Section {i}</p>)}
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="sticky top-0 bg-slate-800 shadow-lg z-10">
  Dashboard
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Sticky with Actions</label>
            <div className="relative h-40 overflow-y-auto bg-slate-950 rounded border border-slate-600">
              <div className="sticky top-0 bg-slate-800 border-b border-slate-600 px-3 py-2 z-10 flex justify-between items-center">
                <span className="font-medium text-slate-300">Settings</span>
                <button className="text-slate-400 hover:text-slate-200"></button>
              </div>
              <div className="p-3 space-y-2 text-sm text-slate-400">
                {[1,2,3,4].map(i => <p key={i}>Setting option {i}</p>)}
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="sticky top-0 z-10 flex justify-between items-center">
  <span>Settings</span>
  <button></button>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Sticky Gradient</label>
            <div className="relative h-40 overflow-y-auto bg-slate-950 rounded border border-slate-600">
              <div className="sticky top-0 bg-gradient-to-r from-slate-800 to-slate-700 px-3 py-2 font-medium text-slate-300 z-10">
                Categories
              </div>
              <div className="p-3 space-y-2 text-sm text-slate-400">
                {[1,2,3,4,5].map(i => <p key={i}>Category {i}</p>)}
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="sticky top-0 bg-gradient-to-r from-slate-800 to-slate-700 z-10">
  Categories
</div>`} />
          </div>
        </div>
      </div>

      {/* ADVANCED STICKY HEADERS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Advanced Variants</h2>
        <div className="grid grid-cols-1 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Colored Sticky Header</label>
            <div className="relative h-40 overflow-y-auto bg-slate-950 rounded border border-slate-600">
              <div className="sticky top-0 bg-amber-900 px-3 py-2 font-medium text-amber-200 z-10 border-b border-amber-700">
                 Search Results
              </div>
              <div className="p-3 space-y-2 text-sm text-slate-400">
                {[1,2,3,4].map(i => <p key={i}>Result {i}</p>)}
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="sticky top-0 bg-amber-900 text-amber-200 z-10">
  Search Results
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Fixed Position Sticky</label>
            <div className="relative h-40 overflow-y-auto bg-slate-950 rounded border border-slate-600">
              <div className="sticky top-0 bg-slate-900 px-3 py-3 font-bold text-slate-200 z-20 shadow-xl border-b-2 border-slate-500">
                Top Section
              </div>
              <div className="p-3 space-y-2 text-sm text-slate-400">
                {[1,2,3,4,5,6].map(i => <p key={i}>Content item {i}</p>)}
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="sticky top-0 bg-slate-900 font-bold z-20 shadow-xl">
  Top Section
</div>`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StickyHeader;


